import { _ as __assign } from '../../chunks/bundle-BsoKutlt.js';
import React__default from 'react';
import { useSendbirdStateContext } from '../../useSendbirdStateContext.js';
import { useChannelContext } from '../context.js';
import { g as getSuggestedReplies } from '../../chunks/bundle-ChbTBhrO.js';
import { a as isDisabledBecauseFrozen, b as isDisabledBecauseMuted } from '../../chunks/bundle-Qz21XT9v.js';
import { M as MessageView } from '../../chunks/bundle-DohVhehS.js';
import { FileViewer } from './FileViewer.js';
import RemoveMessageModal from './RemoveMessageModal.js';
import '../../withSendbird.js';
import '../../chunks/bundle-DDQiHUtN.js';
import '../../chunks/bundle-Cdxj4urY.js';
import '../../chunks/bundle-B_S6iTLS.js';
import '../../chunks/bundle-DqiG00CL.js';
import '../../chunks/bundle-K-ZPPQr-.js';
import '@sendbird/chat/message';
import '../../chunks/bundle-CtiWV1fp.js';
import '../../chunks/bundle-Dcu4oaT9.js';
import '../../chunks/bundle-SFTC4POJ.js';
import '../../chunks/bundle-JoxrNKuk.js';
import '../../chunks/bundle-BsRE6o7w.js';
import '@sendbird/chat/groupChannel';
import '../../chunks/bundle-Bect-58W.js';
import '../../chunks/bundle-D8tzsrR-.js';
import '../../chunks/bundle-B-5tutOE.js';
import '../../chunks/bundle-B0uMDJtX.js';
import '../../chunks/bundle-BmAH27TX.js';
import '../../chunks/bundle-CKHpBJK8.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-BXx8qybA.js';
import '../../chunks/bundle-D9fAlnnY.js';
import '../../chunks/bundle-CAw7uZEI.js';
import '../../Message/hooks/useDirtyGetMentions.js';
import '../../ui/DateSeparator.js';
import '../../chunks/bundle-CLhORKfu.js';
import '../../chunks/bundle-C8lF82nA.js';
import '../../ui/MessageInput.js';
import '../../chunks/bundle-CkidI9AN.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../chunks/bundle-wZ2MFfjI.js';
import 'dompurify';
import '../../chunks/bundle-BmxObDcu.js';
import '../../chunks/bundle-rcslTaFE.js';
import '../../chunks/bundle-BrGYoMhP.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-By8wnYCK.js';
import '../../chunks/bundle-CuhsrQeV.js';
import '../../ui/MessageContent.js';
import '../../chunks/bundle-BImH5oF1.js';
import '../../ui/Loader.js';
import '../../chunks/bundle-BinOSDHU.js';
import '../../chunks/bundle-CzdgvCEO.js';
import '../../ui/MessageItemMenu.js';
import '../../ui/ContextMenu.js';
import 'react-dom';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import '../../ui/SortByRow.js';
import '../../chunks/bundle-C0Yllxsy.js';
import '../../ui/MessageItemReactionMenu.js';
import '../../ui/ImageRenderer.js';
import '../../ui/ReactionButton.js';
import '../../chunks/bundle-ykyO1OLh.js';
import '../../chunks/bundle-DleO6yp8.js';
import '../../ui/EmojiReactions.js';
import '../../ui/ReactionBadge.js';
import '../../ui/BottomSheet.js';
import '../../hooks/useModal.js';
import '../../chunks/bundle-CoaHGciJ.js';
import '../../ui/UserListItem.js';
import '../../chunks/bundle-DFFEB3Ap.js';
import '../../chunks/bundle-Bpnh459j.js';
import '../../ui/MutedAvatarOverlay.js';
import '../../ui/Checkbox.js';
import '../../ui/UserProfile.js';
import '../../sendbirdSelectors.js';
import '../../ui/Tooltip.js';
import '../../ui/TooltipWrapper.js';
import '../../Message/context.js';
import '../../ui/AdminMessage.js';
import '../../ui/QuoteMessage.js';
import '../../chunks/bundle-SmYaD8k7.js';
import '../../chunks/bundle-Db9p7p_C.js';
import '../../ui/ThreadReplies.js';
import '../../ui/OGMessageItemBody.js';
import '../../chunks/bundle-BWAbREcq.js';
import '../../ui/MentionLabel.js';
import '../../ui/LinkLabel.js';
import '../../ui/TextMessageItemBody.js';
import '../../ui/FileMessageItemBody.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-DJ03AWeL.js';
import '../../chunks/bundle-DuCVBYwc.js';
import '../../chunks/bundle-AEltqAUs.js';
import '@sendbird/uikit-tools';
import '../../ui/VoiceMessageItemBody.js';
import '../../ui/ProgressBar.js';
import '../../VoicePlayer/useVoicePlayer.js';
import '../../chunks/bundle-BnF3HgAG.js';
import '../../VoiceRecorder/context.js';
import '../../ui/PlaybackTime.js';
import '../../ui/ThumbnailMessageItemBody.js';
import '../../ui/UnknownMessageItemBody.js';
import '../../ui/TemplateMessageItemBody.js';
import '../../chunks/bundle-wW_bdEVL.js';
import '../../ui/FallbackTemplateMessageItemBody.tsx.js';
import '../../ui/LoadingTemplateMessageItemBody.tsx.js';
import '../../ui/FeedbackIconButton.js';
import '../../ui/MobileFeedbackMenu.js';
import '../../ui/MessageFeedbackModal.js';
import '../../ui/Input.js';
import '../../ui/MessageFeedbackFailedModal.js';
import '../../GroupChannel/components/SuggestedReplies.js';
import '../../chunks/bundle-D8_eHC2p.js';
import '../../chunks/bundle-Brb15PE2.js';
import '../../chunks/bundle-eanZccx-.js';
import '../../chunks/bundle-BvHiq6JB.js';

var Message = function (props) {
    var _a, _b, _c;
    var config = useSendbirdStateContext().config;
    var _d = useChannelContext(), initialized = _d.initialized, currentGroupChannel = _d.currentGroupChannel, animatedMessageId = _d.animatedMessageId, setAnimatedMessageId = _d.setAnimatedMessageId, updateMessage = _d.updateMessage, scrollToMessage = _d.scrollToMessage, replyType = _d.replyType, threadReplySelectType = _d.threadReplySelectType, isReactionEnabled = _d.isReactionEnabled, toggleReaction = _d.toggleReaction, emojiContainer = _d.emojiContainer, nicknamesMap = _d.nicknamesMap, setQuoteMessage = _d.setQuoteMessage, resendMessage = _d.resendMessage, deleteMessage = _d.deleteMessage, renderUserMentionItem = _d.renderUserMentionItem, onReplyInThread = _d.onReplyInThread, onQuoteMessageClick = _d.onQuoteMessageClick, onMessageAnimated = _d.onMessageAnimated, sendMessage = _d.sendMessage, localMessages = _d.localMessages;
    var message = props.message;
    return (React__default.createElement(MessageView, __assign({}, props, { channel: currentGroupChannel, emojiContainer: emojiContainer, editInputDisabled: !initialized || isDisabledBecauseFrozen(currentGroupChannel) || isDisabledBecauseMuted(currentGroupChannel) || !config.isOnline, shouldRenderSuggestedReplies: ((_a = config === null || config === void 0 ? void 0 : config.groupChannel) === null || _a === void 0 ? void 0 : _a.enableSuggestedReplies)
            && (((_b = config === null || config === void 0 ? void 0 : config.groupChannel) === null || _b === void 0 ? void 0 : _b.showSuggestedRepliesFor) === 'all_messages'
                ? true
                : message.messageId === ((_c = currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.lastMessage) === null || _c === void 0 ? void 0 : _c.messageId))
            // the options should appear only when there's no failed or pending messages
            && (localMessages === null || localMessages === void 0 ? void 0 : localMessages.length) === 0
            && getSuggestedReplies(message).length > 0, isReactionEnabled: isReactionEnabled, replyType: replyType, threadReplySelectType: threadReplySelectType, nicknamesMap: nicknamesMap, renderUserMentionItem: renderUserMentionItem, scrollToMessage: scrollToMessage, toggleReaction: toggleReaction, setQuoteMessage: setQuoteMessage, onQuoteMessageClick: onQuoteMessageClick, onReplyInThreadClick: onReplyInThread, sendUserMessage: function (params) {
            sendMessage({
                message: params.message,
                mentionedUsers: params.mentionedUsers,
                mentionTemplate: params.mentionedMessageTemplate,
            });
        }, updateUserMessage: function (messageId, params) {
            updateMessage({
                messageId: messageId,
                message: params.message,
                mentionedUsers: params.mentionedUsers,
                mentionTemplate: params.mentionedMessageTemplate,
            });
        }, resendMessage: resendMessage, deleteMessage: deleteMessage, animatedMessageId: animatedMessageId, setAnimatedMessageId: setAnimatedMessageId, onMessageAnimated: onMessageAnimated, renderFileViewer: function (props) { return React__default.createElement(FileViewer, __assign({}, props)); }, renderRemoveMessageModal: function (props) { return React__default.createElement(RemoveMessageModal, __assign({}, props)); } })));
};

export { Message as default };
//# sourceMappingURL=Message.js.map
